import React from "react";

import "./Pill.scss";

//NOTE -
/*
 * <Pill type={PillType.DEFAULT} size={PillSize.SMALL} style={PillStyle.DARK} text="Tenant" />
 * <Pill type={PillType.DEFAULT} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />
 * <Pill type={PillType.PURPLE} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />
 * <Pill type={PillType.PURPLE} size={PillSize.SMALL} style={PillStyle.DARK} text="Tenant" />
 * <Pill type={PillType.AQUA} size={PillSize.SMALL} style={PillStyle.DARK} text="Tenant" />
 * <Pill type={PillType.AQUA} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />
 * <Pill type={PillType.RED} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />
 * <Pill type={PillType.ORANGE} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />
 */

interface PillProps {
  text: string;
  type: PillType;
  size?: PillSize;
  style?: PillStyle;
}

export enum PillType {
  DEFAULT = "default",
  PURPLE = "purple",
  AQUA = "aqua",
  RED = "red",
  ORANGE = "orange"
}

export enum PillSize {
  SMALL = "small",
  MEDIUM = "medium"
}

export enum PillStyle {
  LIGHT = "light",
  DARK = "dark"
}

const Pill: React.FC<PillProps> = ({ text, type, size, style }) => {
  const className = `pill ${type} ${size ? size : ""} ${style ? style : ""}`.trim();
  return <div className={className}>{text}</div>;
};

export default Pill;
